import { HttpErrorResponse } from "@angular/common/http";
import { AdaptError } from "@common/lib/error-handler/adapt-error";

export class ActivityFeedFetchError extends AdaptError {
    public constructor(error: HttpErrorResponse) {
        super(`Failed to fetch activity: ${error.message}`);
        this.name = "ActivityFetchError";
    }
}
